import { v4 as uuidv4 } from 'uuid';

// Generate once per entry and retain across rerenders/network retries.
export const createSceneSelectionRequestId = () => uuidv4();

export const LIBRARY_PRACTICE_TRIGGER = 'library.before.practice';
export const VOCABULARY_PRACTICE_TRIGGER = 'vocabulary.before.practice';

export const getQuickPracticeSceneTrigger = source =>
  ['preset', 'market'].includes(source?.type) ? LIBRARY_PRACTICE_TRIGGER : null;
